import React from 'react'
import "./Types.css"

export default function type({type}) {
  if (type ==="electric"){ type = "electr"}
  return (
      <b className={type + " title"}>{type.toUpperCase() }</b>
  )
}
